import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { MIDDLE_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      marginBottom: MIDDLE_MARGIN,
    },
    card: {
      backgroundColor: theme.palette.secondary.light,
      display: 'flex',
      flexDirection: 'column',
      marginBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
    },
    info: {
      [theme.breakpoints.up('md')]: {
        minWidth: 450,
        marginRight: MIDDLE_MARGIN,
      },
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    dialog: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:focus': {
        outline: 'none',
      },
    },
  }),
);

export default useStyles;
